import { render, staticRenderFns } from "./message-frame.vue?vue&type=template&id=2a26ee00"
import script from "./message-frame.vue?vue&type=script&lang=js"
export * from "./message-frame.vue?vue&type=script&lang=js"
import style0 from "./message-frame.vue?vue&type=style&index=0&id=2a26ee00&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports